const VIDEO_PREFIX = 'video-360-';
export const return360VideoIdBySceneId = (sceneId) => `${VIDEO_PREFIX}${sceneId}`;
export const is360VideoId = (id) => id.includes(VIDEO_PREFIX);
export const returnSceneIdBy360VideoId = (videoId) => videoId.replace(VIDEO_PREFIX, '');
export const get360VideoIdBySceneId = (sceneId, componentsById) => {
    if (!componentsById)
        return null;
    const scene = componentsById[sceneId];
    return scene.content360?.type === 'video' ? return360VideoIdBySceneId(sceneId) : null;
};
